"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerApiChildSeat = void 0;
var PartnerApiChildSeat;
(function (PartnerApiChildSeat) {
    PartnerApiChildSeat["RearFacing"] = "RearFacing";
    PartnerApiChildSeat["ForwardFacing"] = "ForwardFacing";
    PartnerApiChildSeat["BoosterSeat"] = "BoosterSeat";
    PartnerApiChildSeat["Booster"] = "Booster";
})(PartnerApiChildSeat || (exports.PartnerApiChildSeat = PartnerApiChildSeat = {}));
//# sourceMappingURL=PartnerApiChildSeat.js.map